// Global Guards
/* eslint-disable */

import store from "@/store";
import { findSubSystemByRoute } from "@/config/subSystems.js";
import { getPendingWorkspace } from "@/store/actions.js";

const checkSubSystemAccess = async (to, next) => {
  await store.dispatch("dropdownX/getCompanySubSystems");

  const subSystem = findSubSystemByRoute(to);

  if (!subSystem) return next();

  if (!store.getters["dropdownX/companySubSystemsLoaded"]) return next();

  const owned = store.getters["dropdownX/ownedSubSystemIds"] || [];
  if (owned.indexOf(subSystem.id) !== -1) return next();

  return next({
    name: "ModuleLocked",
    params: { subSystemId: String(subSystem.id) },
  });
};

const beforeEach = (to, from, next) => {
  if (to.meta.requireParsinaSupportAuth) {
    const supportUser = window.localStorage.getItem("mitaParsinaSupportToken");
    if (!supportUser) return next({ name: "parsinaSupportLogin" });
    return next();
  }

  const authUser = window.localStorage.getItem("mitaToken");
  if (to.meta.requiresAuth && !authUser) return next({ name: "Login" });
  if (authUser) return checkSubSystemAccess(to, next);

  return next();
};

const login = (to, from, next) => {
  // اگر کاربر هنوز در مرحلهٔ انتخاب شعبه است (مثلاً بعد از رفرش)، همان‌جا بماند
  if (localStorage.getItem("mitaToken") && !getPendingWorkspace()) {
    return next({ name: "Dashboard" });
  }
  return next();
};

const afterEach = (to, from) => {
  // Put your guard actions here
};

export default {
  beforeEach,
  login,
  afterEach,
};
